<template>
    <div class="py-4 container-fluid">
        <transition name="banner-slide">
            <div v-if="isSyncing || progress === 100">
                <RvoSyncBanner />
            </div>
        </transition>
        <div class="row">
            <div class="col-lg-12">
                <div class="row mt-4">
                    <div class="multisteps-form mb-9">
                        <div class="col-12 col-lg-10 m-auto">
                            <div class="card">
                                <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                    <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3">
                                        <div class="multisteps-form__progress">
                                            <button class="multisteps-form__progress-btn" type="button"
                                                :title="$t('afterdeparture.Arrival_UBN')" :class="activeStep >= 0 ? activeClass : ''">
                                                <span>{{ $t('afterdeparture.Arrival_UBN') }}</span>
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button"
                                                :title="$t('afterdeparture.Animal')" :class="activeStep >= 1 ? activeClass : ''">
                                                <span>{{ $t('afterdeparture.Animal') }}</span>
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" :title="$t('afterdeparture.Departure_UBN')"
                                                :class="activeStep >= 2 ? activeClass : ''">
                                                {{ $t('afterdeparture.Departure_UBN') }}
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" :title="$t('afterdeparture.Arrival_Date')"
                                                :class="activeStep >= 3 ? activeClass : ''">
                                                {{ $t('afterdeparture.Arrival_Date') }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <form class="multisteps-form__form" @submit.prevent="submitForm">
                                        <ubn-info 
                                            v-if="activeStep === 0" 
                                            :class="activeStep === 0 ? activeClass : ''"
                                            :formData="formData" 
                                            :nextStep="nextStep"                                            
                                            :ubns="formData.ubns"                                            
                                            @request-animals="handleAnimalRequest"
                                            @update:formData="updateFormData"
                                        />
                                        <animal-info 
                                            v-if="activeStep === 1" 
                                            :class="activeStep === 1 ? activeClass : ''"
                                            :formData="formData" 
                                            :prevStep="prevStep"
                                            :nextStep="nextStep"
                                            :animals="formData.animals"
                                            @update:formData="updateFormData"
                                        />
                                        <departure-info
                                            v-if="activeStep === 2" 
                                            :class="activeStep === 2 ? activeClass : ''"
                                            :formData="formData" 
                                            :departureubns="formData.departureubns"                                            
                                            :prevStep="prevStep"
                                            :nextStep="nextStep" 
                                            @update:formData="updateFormData"
                                        />
                                        <date-info 
                                            v-if="activeStep === 3" 
                                            :class="activeStep === 3 ? activeClass : ''"
                                            ref="dateInfoRef"
                                            :formData="formData"
                                            :arrivalreasons="formData.arrivalreasons"
                                            :prevStep="prevStep"
                                            :emitter="emitter"
                                        />
                                        <div class="button-row d-flex">
                                            <button
                                                v-if="activeStep === 3"
                                                @click="saveForm"
                                                :disabled="isSaving"
                                                :class="[
                                                    'btn mb-0 btn-sm bg-gradient-success ms-auto',
                                                    { 'disabled opacity-75': isSaving }
                                                ]"
                                                type="button"
                                            >
                                                <span v-if="isSaving" class="spinner-border spinner-border-sm me-2"></span>
                                                {{ isSaving ? $t('common.Saving') : $t('common.Save') }}
                                            </button>
                                        </div>                                      
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>
</template>

<script>
import UbnInfo from "./components/ArrivalUBN.vue";
import AnimalInfo from "./components/Animal.vue";
import DepartureInfo from "./components/DepartureFrom.vue";
import DateInfo from "./components/Date.vue";
import * as Choices from "choices.js";
import { nextTick } from 'vue'
import axios from 'axios'
import mitt from 'mitt';
import { mapState, mapGetters } from 'vuex'

export default {
    name: 'AfterDeparture_page',
    data() {
        return {
            emitter: mitt(),
            activeStep: 0,
            activeClass: "js-active position-relative",
            formSteps: 4,
            formData: {
                associationId: '',
                arrivalUbnId: '',
                animalIds: '',
                departureUbnId: '',
                departureUbn: '',
                departureKeeper: '',
                departureDate: null,
                arrivalReasonId: '',
                note: '',

                ubns:[],
                departureubns:[],
                animals:[],
                arrivalreasons:[]
            },
            // Store Choices instance            
            choicesInstanceUBN: null,
            choicesInstanceDepartureUBN: null,
            choicesInstanceAnimal: null,
            choicesArrivalReason: null,            
            isSaving: false
        };
    },
    components: {
        UbnInfo,
        AnimalInfo,        
        DepartureInfo,
        DateInfo
    },
    async mounted() 
    {
        this.$store.commit('rvoSync/CLEAR_SYNC');
        try {  
            this.associationId = this.$route.params.id;
            this.formData.associationId = this.$route.params.id;
            await this.fetchAllUBN();

        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }
    },    
    computed: {
        userRoleName() {
            return this.$store.state.user?.roleName;
        },
        ...mapState('rvoSync', ['isSyncing', 'progress', 'cancelSource']),
        ...mapGetters('rvoSync', ['elapsedSeconds'])
    },
    watch: {
        'formData.departureUbn'(newValue) {
            const hasText =
                newValue !== null &&
                newValue !== undefined &&
                String(newValue).trim() !== '';

            if (hasText) {
                this.disableDepartureDropdown();
            } else {
                this.enableDepartureDropdown();
            }
        }        
    },
    methods: {        
        disableDepartureDropdown() {
            if (!this.choicesInstanceDepartureUBN) {
                return;
            }

            // Keep actual form value empty
            this.formData.departureUbnId = '';

            // Disable Choices
            this.choicesInstanceDepartureUBN.disable();
        },
        enableDepartureDropdown() {
            if (!this.choicesInstanceDepartureUBN) {
                return;
            }

            this.choicesInstanceDepartureUBN.enable();
        },
        async nextStep() {
            if (this.activeStep < this.formSteps -1) {
                this.activeStep += 1;
                //console.log(this.activeStep);
            } else {
                this.activeStep -= 1;
                //console.log(this.activeStep);
            }   

            await nextTick();

            if(this.activeStep == 2) {
                await this.fetchAllUBN();
                await this.fetchAllDepartureUBN();
            }

            if(this.activeStep == 3) {
                await this.fetchAllArrivalReasons();
            }
        },
        async prevStep() {
            if (this.activeStep > 0) {
                this.activeStep -= 1;
                //console.log(this.activeStep);

                if(this.activeStep == 0) {
                    //await this.fetchAllUBNData();
                    await this.fetchAllUBN();
                }
                
                if(this.activeStep == 1) {
                    //await this.fetchAllAnimals();
                }

                if(this.activeStep == 2) {
                    await this.fetchAllUBN();
                    await this.fetchAllDepartureUBN();                    
                }

                if(this.activeStep == 3) {
                await this.fetchAllArrivalReasons();
            }
            }
        },        
        async fetchAllUBN() {
            try {
                this.$store.commit('setShowLoading', true);

                const response = await axios.get(
                    "Location/getallbyassociationdeparture",
                    {
                        params: {
                            associationId: this.formData.associationId
                        }
                    }
                );

                const result = response.data;

                if (result.success && Array.isArray(result.data)) {
                    
                    let avl_ubns = result.data;

                    // Do not show the selected Departure UBN in the Arrival UBN dropdown.
                    if (this.formData.departureUbnId) {
                        avl_ubns = avl_ubns.filter(
                            item => item.id !== this.formData.departureUbnId
                        );
                    }

                    this.formData.ubns = avl_ubns;

                    if (!this.formData.arrivalUbnId) {
                        this.formData.arrivalUbnId = '';
                        this.formData.ubn = '';
                    }
                    
                    await nextTick();

                    this.initializeChoicesDropdown({
                        id: "arrivalUbnId",
                        dataList: this.formData.ubns,
                        selectedValue: this.formData.arrivalUbnId,
                        instanceKey: "choicesInstanceUBN"
                    });                    
                } else {
                    this.$showSuccess('errors.Error_fetching_ubns');
                }

            } catch (e) {
                const errorMessage =
                    e.response?.data?.message ||
                    e.message ||
                    this.$t('errors.Something_went_wrong');

                this.$showError(
                    `${this.$t('errors.Contact_system_admin')}: ${errorMessage}`
                );
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },
        async fetchAllDepartureUBN()
        {
            this.$store.commit('setShowLoading', true);
            try { 
                const response = await axios.get("Location/getallbyassociationdeparture", {
                    params: {
                        associationId: this.associationId
                    }
                });
                const result = response.data;

                if (result.success && Array.isArray(result.data)) {
                    let avl_dubns = result.data;
                    
                    let arrivalUbnId = this.formData.arrivalUbnId;
                
                    if (arrivalUbnId) {                        
                        avl_dubns = avl_dubns.filter(l => l.id !== arrivalUbnId);
                    }

                    this.formData.departureubns = avl_dubns;
                    await nextTick();

                    this.initializeChoicesDropdown({
                        id: "departureUbnId",
                        dataList: this.formData.departureubns,
                        selectedValue: this.formData.departureUbnId,
                        instanceKey: "choicesInstanceDepartureUBN"
                    });

                    if (this.formData.departureUbn && String(this.formData.departureUbn).trim() !== ''
                    ) {
                        this.disableDepartureDropdown();
                    } else {
                        this.enableDepartureDropdown();
                    }
                } else {    
                    this.$showSuccess('errors.Error_fetching_ubns');
                }   
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },
        async fetchAllArrivalReasons()
        {
            this.$store.commit('setShowLoading', true);
            try {
                const response = await axios.get("reference/getreference", {
                    params: {
                        referenceTypeId: '54EE384D-8540-4662-B588-EC05AFD435DB'
                    }
                });
                const result = response.data;

                if (result.success && Array.isArray(result.data)) {
                    
                    this.formData.arrivalreasons = result.data;
                    await nextTick();

                    this.initializeChoicesDropdown({
                        id: "arrivalReasonId",
                        dataList: this.formData.arrivalreasons,
                        selectedValue: this.formData.arrivalReasonId,
                        instanceKey: "choicesArrivalReason"
                    });
                } else {    
                    this.$showSuccess('errors.Error_fetching_arrival_reason');
                }                
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },
        async handleAnimalRequest() {
            this.formData.associationId = this.$route.params.id;

            this.$store.commit('setShowLoading', true);
            try {
                const response = await axios.get("Animal/GetAllAfterArrivalAnimal", {
                    params: {
                        associationId: this.$route.params.id
                    }
                });
                if (response.data.success) {
                    if(response.data.count > 0 && Array.isArray(response.data.data)) {
                        this.formData.animals = response.data.data.sort((a, b) => (b.animalNumber ?? '').localeCompare(a.animalNumber ?? ''));
                        this.nextStep();
                    } else {
                        this.$showSuccess('errors.Success_no_animal_found');
                    }
                } else {
                    this.$showError(this.$t('errors.Error_fetching_animals'));
                }
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },              
        initializeChoicesDropdown({ id, dataList, selectedValue, instanceKey }) {
            const element = document.getElementById(id);

            if (!element || element.tagName !== "SELECT") {
                console.error(
                    `Choices: Invalid or missing select element with ID "${id}".`
                );
                return;
            }

            if (this[instanceKey]) {
                this[instanceKey].destroy();
                this[instanceKey] = null;
            }

            this[instanceKey] = new Choices(element, {
                searchEnabled: true,
                itemSelectText: '',
                shouldSort: false,
                placeholder: true,
                placeholderValue: element.options[0]?.text || ''
            });

            if (selectedValue) {
                const optionExists = dataList.some(
                    item => String(item.id) === String(selectedValue)
                );

                if (optionExists) {
                    this[instanceKey].setChoiceByValue(String(selectedValue));
                }
            }
        },
        updateFormData(updatedData) {
            Object.assign(this.formData, updatedData);

            if (this.formData.arrivalUbnId && this.formData.departureUbnId && String(this.formData.arrivalUbnId) === String(this.formData.departureUbnId)) {
                this.formData.departureUbnId = '';
                this.formData.departureUbn = '';
                this.formData.departureKeeper = '';
            }
        },
        async saveForm() {
            if (this.isSaving) return; // prevent double click
            this.isSaving = true;

            try {
                const isValid = await this.$refs.dateInfoRef?.validateAndSubmit();
                if (!isValid) {
                    this.isSaving = false;
                    return;
                }

                await this.submitForm();

            } catch (e) {
                console.error(e);
            } finally {
                this.isSaving = false;
            }
        },
        async submitForm() {

            this.$store.commit("setShowLoading", true);

            try {

                const formData = new FormData();
                const ignoredKeys = ["ubns", "departureubns", "animals", "arrivalreasons"];

                for (const key of Object.keys(this.formData)) {

                    if (ignoredKeys.includes(key))
                        continue;

                    const value = this.formData[key];

                    if (key === "departureDate" && value instanceof Date) {
                        formData.append(key, value.toISOString().split("T")[0]);
                    }
                    else if (value !== null && value !== undefined) {
                        formData.append(key, value);
                    }
                }

                await this.createDeparture(formData);

                this.$showSuccess(this.$t("errors.Success_departure_created_successfully"));
                this.$router.push("/afterdeparture");
            }
            catch (e) {
                if (!axios.isCancel(e)) {
                    const message = e.response?.data?.message || e.message || this.$t("errors.Something_went_wrong");
                    this.$showError(message);
                }
            }
            finally {
                this.$store.commit("setShowLoading", false);
            }
        },        
        async createDeparture(formData) {

            const response = await axios.post(
                "/afterdeparture/create",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                });

            if (!response?.data?.success) {
                throw new Error(response?.data?.message || this.$t("errors.Something_went_wrong"));
            }
            return response.data;
        }        
    }
}
</script>
<style>

.choices[data-type*=select-one]::after {
  display: none !important;
}

.choices__inner {
  border: none !important;
  background-color: transparent !important;
  box-shadow: none !important;
  position: relative;
}

.choices[data-type*=select-one] .choices__inner::before {
  content: "";
  position: absolute;
  right: 12px;
  top: 50%;
  width: 0;
  height: 0;
  pointer-events: none;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #666;
  transform: translateY(-50%);
}

/* Hide weird characters or fallback icons */
.choices__inner > *:not(.choices__item) {
  font-family: inherit !important;
  content: none !important;
}


.choices__placeholder {
  color: #999 !important;
  font-style: italic !important;
}

.choices__list--single {
  padding: 0px !important;
}

.banner-slide-enter-active,
.banner-slide-leave-active {
    transition: all 0.4s ease;
}

.banner-slide-enter-from {
    transform: translateY(-20px);
    opacity: 0;
}

.banner-slide-leave-to {
    transform: translateY(-20px);
    opacity: 0;
}

.custom-textarea {
border: 1px solid #ced4da !important;
border-radius: 4px !important;
padding: 0.5rem !important;  
}
</style>